import { h } from '@atomify/jsx';
import { Image } from '@atoms/image';
import {
    COLOR_CLASSES,
    FormattedPrice,
    FormattedSpecification,
    FormattedStatus,
} from '@source/utilities/api-formatters';
import { useTranslate } from '@utilities/hooks';

interface ProjectPhaseCardInterface {
    title: string;
    id?: string;
    image?: string | null;
    price?: FormattedPrice;
    specs?: FormattedSpecification[];
    status?: FormattedStatus;
    housesAmount?: number;
    classes?: string;
    hidePrice?: boolean;
    debugId?: string;
}

export const ProjectPhaseCard = ({
    classes = '',
    id,
    image,
    title,
    status,
    housesAmount,
    price,
    specs,
    hidePrice,
    debugId,
}: ProjectPhaseCardInterface) => (
    <div class={`c-project-phase-card ${classes}`} {...(id && { id })}>
        {debugId && <span class="project-phase-card__debug-id">{debugId}</span>}

        <div class="project-phase-card__image-container">
            {image && (
                <Image
                    image={image}
                    settings={{
                        '640w': {
                            width: 232,
                            height: 144,
                        },
                    }}
                    classes="project-phase-card__image"
                    alt={`${title} image`}
                    objectFit={true}
                />
            )}
        </div>

        <div class="project-phase-card__details">
            {status && (
                <span class={`project-phase-card__status ${COLOR_CLASSES[status.color]}`}>
                    {status.label}
                </span>
            )}

            {housesAmount && (
                <span class="project-phase-card__houses-amount u-color--grey-30">
                    {` - ${housesAmount} `}
                    {useTranslate(housesAmount === 1 ? 'House' : 'Houses')}
                </span>
            )}

            <p class="project-phase-card__title">{title}</p>

            {price?.amount && !hidePrice && (
                <div class="project-phase-card__price">
                    {price.prefix && price.prefix} {price.amount && price.amount}{' '}
                    {price.suffix && price.suffix}
                </div>
            )}

            {specs && (
                <ul class="project-phase-card__specs">
                    {specs.map(({ value, suffix }) => (
                        <li class="project-phase-card__spec">
                            {value} {suffix}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    </div>
);
